var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.552 23.328L3.024 12.896C2.576 12.48 2.224 12 1.904 11.488C0.175998 8.64 0.623998 4.992 3.024 2.624C4.4 1.248 6.256 0.480003 8.208 0.480003C11.28 0.480003 13.2 2.272 14 3.296C14.8 2.272 16.72 0.480003 19.792 0.480003C21.744 0.480003 23.6 1.248 24.976 2.624C27.344 4.992 27.824 8.64 26.096 11.488C25.776 12 25.424 12.48 24.976 12.896L14.448 23.328C14.192 23.584 13.808 23.584 13.552 23.328ZM8.208 1.76C6.576 1.76 5.072 2.4 3.92 3.52C1.968 5.472 1.584 8.48 2.992 10.816C3.248 11.232 3.568 11.648 3.92 12L14 21.984L24.08 12C24.432 11.648 24.752 11.264 25.008 10.816C26.416 8.448 26.064 5.44 24.08 3.52C22.928 2.4 21.392 1.76 19.792 1.76C17.488 1.76 15.568 3.008 14.544 4.736C14.288 5.152 13.68 5.152 13.424 4.736C12.432 3.008 10.512 1.76 8.208 1.76Z",
    fill: "#6B8E76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.d49e469c60e08ff681c161f9af4d0c03.svg";
export { ForwardRef as ReactComponent };